const BASE_URL = process.env.REACT_APP_ZVB_URL;


// GET API

// API to fetch Services
export const fetchServices = async () => {
  try {
    const response = await fetch(BASE_URL + "/services");

    if (!response.ok) {
      throw new Error("Network response error.");
    }

    const data = await response.json();

    // console.log("Fetched services data:", data);

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Error fetching services:", error);
    return [];
  }
};

// API to fetch appointments
export const fetchAppointments = async (id) => {

  try {
    const response = await fetch(BASE_URL + "/checkAppointment?id=" + id);

    if (!response.ok) {
      throw new Error("Network response error.");
    }
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.error("Error while fetching Appointment");
  }

}


// POST API 


// API to create Appointments
export const getAvailabilities = async (payload) => {
  const res = await fetch(BASE_URL + "/availability?date=" + payload.date);
  if (!res.ok) throw new Error("Failed to get availabilities");
  return res.json();
};


export const createAppointment = async (payload) => {
  console.log(payload)
  const res = await fetch(BASE_URL + "/appointments", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error("Failed to create appointment");
  return res.json();
};
